import { PropsWithChildren } from 'react';

import { PasswordValidation } from 'helpers';
import { useTranslation } from 'libs/i18n';

import {
  ChangePasswordFormSubmit,
  Form,
  getSchema,
  FormErrors,
} from '../../forms/changePasswordForm';

export interface PasswordSettingsFormProps {
  initialErrors?: FormErrors;
  passwordValidation: PasswordValidation;
  onSubmit: ChangePasswordFormSubmit;
}

export const PasswordSettingsForm = ({
  children,
  passwordValidation,
  initialErrors,
  onSubmit,
}: PasswordSettingsFormProps & PropsWithChildren) => {
  const { t } = useTranslation();

  const schema = getSchema(t, passwordValidation);

  return (
    <Form
      initialErrors={initialErrors}
      initialValues={{ oldPassword: '', newPassword: '' }}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      {children}
    </Form>
  );
};
